import {
  Box,
  chakra,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { DownloadIcon } from '~components/ui/icons/DownloadIcon';
import { ZteRowFragment } from './__generated__/ZteTable.graphql';

export interface ZteDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  row: ZteRowFragment;
}

export const ZteDetailsModal: React.FC<ZteDetailsModalProps> = ({ isOpen, onClose, row }) => {
  return (
    <Modal size="6xl" isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent p={4}>
        <ModalCloseButton />
        <ModalHeader pb={6}>{row.batchName}</ModalHeader>
        <ModalBody pb={8}>
          <Stack direction="row" spacing={8} wrap="wrap">
            <Box minW="350px">
              <VStack align="start" spacing={4}>
                <Text>
                  <strong>Customer:</strong> <chakra.span pl={2}>{row.customerName}</chakra.span>
                </Text>
                <Text>
                  <strong>CSV File Name:</strong>
                  <chakra.span pl={2}>{row.fileName}</chakra.span>
                </Text>
                <Text>
                  <strong>Date Created:</strong>
                  <chakra.span pl={2}>
                    {new Date(row.createdAt).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </chakra.span>
                </Text>
              </VStack>
            </Box>
            <Box minW="350px">
              <VStack align="start" spacing={4}>
                <Text>
                  <strong>All Discovered Rows:</strong>{' '}
                  <chakra.span pl={2}>{row.totalDisplay}</chakra.span>
                </Text>
                <Text>
                  <strong>Validated:</strong> <chakra.span pl={2}>{row.validated}</chakra.span>
                </Text>
                <Text>
                  <strong>Devices Paired:</strong>{' '}
                  <chakra.span pl={2}>{row.pairedDisplay}</chakra.span>
                </Text>
                <Text>
                  <strong>Devices Claimed:</strong>{' '}
                  <chakra.span pl={2}>{row.claimedDisplay}</chakra.span>
                </Text>
              </VStack>
            </Box>
            <Box minW="250px">
              <VStack align="start" spacing={4}>
                <Text>
                  <strong>Unpaired Devices:</strong>{' '}
                  <chakra.span pl={2}>
                    {Math.max(0, (row.validated ?? 0) - (row.pairedDisplay ?? 0))}
                  </chakra.span>
                </Text>
                <Text>
                  <strong>UnClaimed Devices:</strong>{' '}
                  <chakra.span pl={2}>{row.unClaimedDisplay}</chakra.span>
                </Text>
                <Text>
                  <strong>Failed to Validate:</strong>
                  <chakra.span pl={2}>
                    {row.totalDisplay != null && row.validated != null
                      ? row.totalDisplay - row.validated
                      : ''}
                  </chakra.span>
                </Text>
                <Text>
                  <strong>Download File:</strong>
                  <chakra.span whiteSpace="nowrap" pl={2}>
                    {row.status === 'UPLOADED' && row.downloadUrl ? (
                      <chakra.span whiteSpace="nowrap">
                        <Box as="a" href={row.downloadUrl} download cursor={'pointer'} opacity={1}>
                          <DownloadIcon width="5" height="5" />
                        </Box>
                      </chakra.span>
                    ) : (
                      <chakra.span whiteSpace="nowrap">
                        <Spinner size="sm" />
                      </chakra.span>
                    )}
                  </chakra.span>
                </Text>
              </VStack>
            </Box>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
